import { render } from "./DictionaryTree.vue?vue&type=template&id=2771aa46&scoped=true"
import script from "./DictionaryTree.vue?vue&type=script&lang=js"
export * from "./DictionaryTree.vue?vue&type=script&lang=js"

import "./DictionaryTree.vue?vue&type=style&index=0&id=2771aa46&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2771aa46"]])

export default __exports__